import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Alert, Button, FormLabel, FormControl, FormGroup, FormText } from 'react-bootstrap'
import {
  cancelProcessTransactionStartModalDialog,
  closeProcessTransactionStartModalDialog,
  submitProcessTransactionStartModalDialog,
  startManualAml,
  validateProcessTransactionStartModalDialog,
} from '../../actions/start_process_transaction'
import { fetchUserTxById } from '../../actions'
import Spinner3Bounce from '../spinner_3_bounce'

class ProcessTransactionStartForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      notes: null,
      notesValidated: null,
      notesValidationState: null,
    }
  }

  handleSaveChanges(e) {
    const { startManualAml, txId, submitProcessTransactionStartModalDialog } = this.props
    // create patch object

    let newData = { notes: this.state.notes }
    if (!this.state.notesValidated) {
      window.alert('Please enter notes')
      return
    }

    startManualAml(txId, newData)
    submitProcessTransactionStartModalDialog(newData)
  }

  validateNotes(e) {
    const value = e.target.value
    this.setState({ notes: value })
    let result = 'success'
    if (value.length < 1) {
      result = 'error'
    }
    if (result === 'error') {
      this.setState({ notesValidated: false, notesValidationState: result })
    }
    if (result === 'success') {
      this.setState({ notesValidated: true, notesValidationState: result })
    }
  }

  handleCloseModal(e) {
    const { closeProcessTransactionStartModalDialog, fetchUserTxById, txId } = this.props
    fetchUserTxById(txId)
    closeProcessTransactionStartModalDialog()
  }

  render() {
    const { cancelProcessTransactionStartModalDialog, isSubmitted, isValidated, isSuccessSubmit, error } = this.props
    let notes = this.state.notes || ''

    return (
      <form>
        {!isSubmitted && !isSuccessSubmit && (
          <FormGroup controlId='notes'>
            <FormLabel>Notes</FormLabel>
            <FormControl
              style={{ height: '180px' }}
              value={notes}
              as='textarea'
              onChange={(e) => this.validateNotes(e)}
            />
            <FormControl.Feedback />
            <FormText className='small'>
              <em>Required</em>
            </FormText>
          </FormGroup>
        )}
        {isSubmitted && isSuccessSubmit === null && <Spinner3Bounce isActive />}
        {isSubmitted && isSuccessSubmit && (
          <Alert className='m-b-sm m-t-sm' variant='success'>
            Success: Processing transaction
          </Alert>
        )}
        {isSuccessSubmit === false && (
          <Alert className='m-b-sm m-t-sm' variant='danger'>
            Error: {error}
          </Alert>
        )}
        <div className='text-end'>
          {isSubmitted && isSuccessSubmit ? (
            <Button className='m-r-sm' onClick={(e) => this.handleCloseModal(e)}>
              Close
            </Button>
          ) : (
            <Button className='m-r-sm' onClick={() => cancelProcessTransactionStartModalDialog()}>
              Cancel
            </Button>
          )}
          {!isSubmitted && isValidated && (
            <Button variant='primary' onClick={(e) => this.handleSaveChanges(e)}>
              Submit
            </Button>
          )}
          {!isSubmitted && !isValidated && (
            <Button disabled variant='primary' onClick={(e) => this.handleSaveChanges(e)}>
              Submit
            </Button>
          )}
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state) => ({
  isSubmitted: state.processTransactionStartModalDialog.isSubmitted,
  isValidated: state.processTransactionStartModalDialog.isValidated,
  isSuccessSubmit: state.processTransactionStartModalDialog.isSuccessSubmit,
  error: state.processTransactionStartModalDialog.error,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      validateProcessTransactionStartModalDialog,
      closeProcessTransactionStartModalDialog,
      cancelProcessTransactionStartModalDialog,
      submitProcessTransactionStartModalDialog,
      startManualAml,
      fetchUserTxById,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProcessTransactionStartForm))
